import React, { useContext } from "react";
import createPaymentPlanPageStyle from "../../assets/jss/xrs/views/createPaymentPlanPageStyle";
import { makeStyles } from "tss-react/mui";
import HeaderSectionLoggedID from "../SectionsPage/Sections/HeaderSectionLoggedID.js";
import WizardSection from "../SectionsPage/Sections/WizardSection.js";
import Context from "../../utils/context";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;
import { primaryColor } from "assets/jss/xrs.js";
import { Box } from "@mui/material";

let drawerWidth = 150;
if (isMobile) {
  drawerWidth = 0;
}
const useStyles2 = makeStyles()((theme) => createPaymentPlanPageStyle(theme));
export default function LandingPage(props) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  const context = useContext(Context);
  const { classes: classes2, cx } = useStyles2();

  return (
    <Box component="div" sx={{ backgroundColor: primaryColor[14] }}>
      <HeaderSectionLoggedID
        page="createPayment"
        title="Create payment plan"
      ></HeaderSectionLoggedID>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <main
            className={cx(classes2.content, {
              [classes2.contentShift]: context.stateDrawer,
            })}
          >
            <WizardSection></WizardSection>
          </main>
        </GridItem>
      </GridContainer>
    </Box>
  );
}
